// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"input-group_inputGroup__2anjX","labelPart":"input-group_labelPart__2bGRg","inputPart":"input-group_inputPart__N7VF2"};